import axios from "axios";

export async function fetchConfigActivityGroups(projectId) {
  try {
    const { data } = await axios.get(`/api/v2/project/${projectId}/configs`);
    return data.data.activity_groups || null;

  } catch (e) {
    let error = null;

    if (axios.isAxiosError(e)) {
      // console.error("Error de red al cargar configuración del proyecto", e.message);
      error = new Error("Fallo en la solicitud HTTP para obtener la configuración del proyecto.");
    } else {
      // console.error("Error inesperado al cargar configuración del proyecto", e);
      error = new Error("No se pudo cargar la configuración del proyecto.");
    }

    error.original = e;
    throw e;
  }
}

export async function fetchActivityGroups(projectId) {
  try {
    const groupRes = await axios.get(`/api/v2/project/${projectId}/activity/groups`)
    const groups = groupRes.data.groups || [];
    return groups;
  } catch (e) {
    let error = null;

    if (axios.isAxiosError(e)) {
      // console.error("Error de red al cargar configuración del proyecto", e.message);
      error = new Error("Fallo en la solicitud HTTP para obtener la configuración del proyecto.");
    } else {
      // console.error("Error inesperado al cargar grupo de actividades del proyecto", e);
      error = new Error("No se pudo cargar log grupos de actividades del proyecto.");
    }

    error.original = e;
    throw e;
  }
}

export async function persistActivityGroupConfig(projectId, payload) {
  const { data } = await axios.post(`/api/v2/project/${projectId}/configs`, payload);
  return data;
}

export async function assignCustomCodesToActivityGroups(payload) {
  const { data } = await axios.patch('/api/v2/activity-groups/assign-code-custom', payload)
  return data;
}

// Proyectos de la misma empresa (accesibles) con config de informe detallado, para
// reutilizar su configuración. Devuelve [{ id, name }].
export async function fetchReportConfigSources(projectId) {
  const { data } = await axios.get(`/api/v2/project/${projectId}/report-config-sources`)
  return (data && data.data) || []
}